class EventBus {
  on(eventName, callback) {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);
  }
  emit(eventName) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (!this.events[eventName]) {
      return;
    }
    this.events[eventName].forEach(callback => callback(...args));
  }
  off(eventName, callback) {
    if (!this.events[eventName]) {
      return;
    }
    this.events[eventName] = this.events[eventName].filter(cb => cb !== callback);
  }
  once(eventName, callback) {
    var _this = this;
    const fn = function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      callback(...args);
      _this.off(eventName, fn);
    };
  }
  constructor() {
    this.events = {};
  }
}
export default new EventBus();